import React, { useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Slider from '../Carousel/Slider';
import Course from '../Course/Course';


const Home = () => {
    const [courses, setCourses] = useState([]);
    /* get json data  */
    useEffect(() => {
        fetch('./courses.JSON')
            .then(res => res.json())
            .then(data => setCourses(data.slice(0, 3)))

    }, [])

    return (
        /* using map passed it */
        <div >
            <h1 className="text-center m-5 font-weight-bold">SiliCone Online Dev School</h1>
            <Slider></Slider>
            <h2 className="text-center mt-5 font-weight-bold">Highlight Courses</h2>
            <Row xs={1} md={3} className="g-4 px-5 pt-3">

                {
                    courses.map(course => <Course
                        key={course.id}
                        course={course}
                    ></Course>)
                }

            </Row>
            <div className="text-end pe-5 me-2" >
                <Link to='/courses'>see more</Link>
            </div>
        </div>
    );
};

export default Home;